import {CloseOutlined, MenuOutlined} from '@ant-design/icons';
import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import drawerContentTypes from '../../../consts/drawer/drawerContentTypes';
import useNotificationStream from '../../../hooks/useNotificationStream';
import {toggleDrawer} from '../../../state/ducks/drawer';
import {fetchNotifications, makeNotificationsSelector} from '../../../state/ducks/notifications';
import {makeSelectAuthToken, makeSelectLogin} from '../../../state/selectors/auth';
import {makeSelectCurrentUserInfo} from '../../../state/selectors/currentUser';
import {makeSelectDrawerContentType, makeSelectIsDrawerVisible} from '../../../state/selectors/drawer';
import Logo from '../../Logo/Logo';
import Profile from '../../UserMenu/UserMenu';
import UserNotifications from '../../UserNotifications/UserNotifications';

const HEADER_CLASSES = `
    app-layout-header h-[67px] bg-white flex justify-between items-center
    sticky top-0 w-full border-b border-b-whisper drop-shadow-lg
    px-3 md:pl-[31px] md:pr-7 z-[1010]
`;

const Header = ({isMobileMenuOpened, onMobileMenuClick}) => {
    const dispatch = useDispatch();

    const login = useSelector(makeSelectLogin());
    const authToken = useSelector(makeSelectAuthToken());
    const currentUserInfo = useSelector(makeSelectCurrentUserInfo());
    const {unreadCount} = useSelector(makeNotificationsSelector());
    const isDrawerVisible = useSelector(makeSelectIsDrawerVisible());
    const drawerContentType = useSelector(makeSelectDrawerContentType());

    const isUserReady = !!(authToken && currentUserInfo);

    useNotificationStream(isUserReady);

    useEffect(() => {
        if (isUserReady) {
            dispatch(fetchNotifications());
        }
    }, [dispatch, isUserReady]);

    const onNotificationsClick = useCallback(() => {
        dispatch(toggleDrawer(drawerContentTypes.NOTIFICATIONS));
        dispatch(fetchNotifications());
    }, [dispatch]);

    return (
        <header className={HEADER_CLASSES}>
            <Logo />
            <div className='flex items-center gap-2 select-none md:gap-0'>
                {currentUserInfo && (
                    <UserNotifications
                        onClick={onNotificationsClick}
                        count={unreadCount}
                        isOpen={isDrawerVisible && drawerContentType === drawerContentTypes.NOTIFICATIONS}
                    />
                )}
                <button
                    type='button'
                    aria-label={isMobileMenuOpened ? 'Закрити меню' : 'Відкрити меню'}
                    aria-expanded={isMobileMenuOpened}
                    aria-controls='mobile-navigation'
                    aria-haspopup='dialog'
                    className='flex h-11 w-11 shrink-0 items-center justify-center rounded-10 bg-cultured transition-colors hover:bg-theme-whisper md:hidden'
                    onClick={onMobileMenuClick}
                >
                    {isMobileMenuOpened ? (
                        <CloseOutlined className='text-20 text-charcoal' aria-hidden />
                    ) : (
                        <MenuOutlined className='text-20 text-charcoal' aria-hidden />
                    )}
                </button>
                <div className='hidden md:block'>
                    <Profile userName={authToken ? login : null} />
                </div>
            </div>
        </header>
    );
};

export default Header;
